import { Link } from "react-router-dom";
import Seo from "@/components/Seo";
import { usePublicData } from "@/lib/publicData";
import { PageHero, Container, Reveal, CtaBand } from "@/components/public/parts";
import { MapPin, ArrowRight } from "lucide-react";

export default function ServiceAreas() {
  const data = usePublicData();
  const areas = data?.settings?.service_areas || ["Columbus", "Cleveland", "Cincinnati"];
  return (
    <>
      <Seo title="Service Areas | Love For Mankind Ohio" description="Love For Mankind provides disability and community support services across Columbus, Cleveland, Cincinnati and surrounding Ohio communities." path="/service-areas" />
      <PageHero eyebrow="Where We Serve" title="Service Areas" sub="Compassionate care across Ohio's communities." breadcrumbs={[{ label: "Home", to: "/" }, { label: "Service Areas" }]} />
      <Container className="py-16 lg:py-24">
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {areas.map((a, i) => (
            <Reveal key={a} delay={i * 0.05}>
              <div className="rounded-2xl border border-border bg-card p-7">
                <div className="w-12 h-12 rounded-xl bg-secondary flex items-center justify-center"><MapPin className="w-6 h-6 text-primary" /></div>
                <h2 className="font-heading text-2xl font-semibold mt-4">{a}, Ohio</h2>
                <p className="text-[15px] text-muted-foreground mt-2 leading-[1.65]">Supported living, day support, vocational habilitation, personal care and accessible transportation available in and around {a}.</p>
                <Link to="/request-services" className="inline-flex items-center gap-1.5 text-primary font-semibold text-sm mt-4">Request services here <ArrowRight className="w-4 h-4" /></Link>
              </div>
            </Reveal>
          ))}
        </div>
      </Container>
      <CtaBand />
    </>
  );
}
